export const COUNTRY_CONFIG = {
    VN: "Vietnam",
    TH: "Thailand",
    PH: "Philippines",
    MY: "Malaysia",
    SG: "Singapore",
    ID: "Indonesia",
    OTHER: "Other",
}